module.exports = __webpack_public_path__ + "img/wheel.9242b2b0.png";